import './index.scss'

class NextWine {
    constructor(el) {
        this.$el = el
    }
    
    init() {
    }
}

document.addEventListener('DOMContentLoaded', () => {
    [ ...document.querySelectorAll('.acf-next-wine') ].forEach($block => {
        $block.expandygg = new NextWine($block)
    })
}, {capture: false, passive: true, once: true} || false)